import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[lDisabled]',
  standalone: true
})
export class Disabled implements AfterViewInit {

  constructor(
    private readonly element: ElementRef,
  ) { }

  @Input('disableType')
  public type?: 'full' | 'visual' | 'no-visual' | 'hidden' = 'full';

  @Input('lDisabled')
  public set value(v: boolean) {
    this._value = v;
    this.define();
  };

  private _value?: boolean | '' = true;

  public ngAfterViewInit(): void {
    this.define();
  }

  public define(): void {
    if (this._value === '')
      this._value = true

    const classList = this.element.nativeElement.classList;
    const OPACITY_CLASS = 'opacity-50';
    const POINTER_CLASS = 'pointer-events-none';
    const HIDDEN_CLASS = 'hidden';

    classList.remove(OPACITY_CLASS);
    classList.remove(POINTER_CLASS);
    classList.remove(HIDDEN_CLASS);

    if (!this._value)
      return;

    if (this.type === 'full') {
      classList.add(OPACITY_CLASS);
      classList.add(POINTER_CLASS);
    }

    if (this.type === 'visual')
      classList.add(OPACITY_CLASS);

    if (this.type === 'no-visual')
      classList.add(POINTER_CLASS);

    if (this.type === 'hidden')
      classList.add(HIDDEN_CLASS);
  }

}
